<script lang="ts" setup>
import { NavigationMenuLink } from 'reka-ui';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">信息公示</div>
      <ul class="m-0 w-331 flex flex-col list-none gap-y-16 p-0">
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/information/regulation" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              管理制度与证照
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/information/bidding" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              招投标信息公示
            </RouterLink>
          </NavigationMenuLink>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">报告</div>
      <ul class="m-0 w-331 flex flex-col list-none gap-y-16 p-0">
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/information/work" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              工作报告
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/information/audit" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              审计报告
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/information/insight" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              开源态势洞察
            </RouterLink>
          </NavigationMenuLink>
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
